import { Box } from '@mui/material';
import React from 'react';
import { Outlet } from 'react-router';

export const GuestLayout: React.FC = (): JSX.Element => {
  return (
    <Box>
      <Outlet />
    </Box>
  );
};
